module.exports = __webpack_public_path__ + "img/img_cloud_l.cb3991aa.png";